import { FormType, Formula } from '../../Formula';
import { AggregateFunction } from '../Funcs/AggFunc';
const aggFuncs = new Set([
    AggregateFunction.AVG,
    AggregateFunction.COUNT,
    AggregateFunction.COUNTD,
    AggregateFunction.MEDIAN,
    AggregateFunction.MIN,
    AggregateFunction.MAX,
    AggregateFunction.STDEV,
    AggregateFunction.STDEVP,
    AggregateFunction.SUM,
    AggregateFunction.VAR,
    AggregateFunction.VARP,
]);
export class AggFormula extends Formula {
    static Matches(tree) {
        if (tree.root.type !== 'CallExpression') {
            return false;
        }
        else {
            const callNode = tree.root;
            if (!aggFuncs.has(callNode.callee)) {
                return false;
            }
            else if (callNode.arguments.length !== 1) {
                return false;
            }
            else if (callNode.arguments[0].type !== 'FieldLiteral') {
                return false;
            }
        }
        return true;
    }
    constructor(tree, compiler) {
        super(tree, compiler);
        const callNode = tree.root;
        const fieldNode = callNode.arguments[0];
        switch (callNode.callee) {
            case AggregateFunction.AVG:
            case AggregateFunction.COUNT:
            case AggregateFunction.COUNTD:
            case AggregateFunction.MEDIAN:
            case AggregateFunction.MIN:
            case AggregateFunction.MAX:
            case AggregateFunction.STDEV:
            case AggregateFunction.STDEVP:
            case AggregateFunction.SUM:
            case AggregateFunction.VAR:
            case AggregateFunction.VARP:
                this._funcName = callNode.callee;
                break;
            default:
                this._funcName = AggregateFunction.AGG;
        }
        this._fieldName = fieldNode.value;
    }
    get form() {
        return FormType.AGGFUNC;
    }
    get funcName() {
        return this._funcName;
    }
    get fieldName() {
        return this._fieldName;
    }
}
